export default 'referencesApp';
